import {ErrorHandler, isDevMode} from "@angular/core";

import {Subject} from "rxjs";

export class AppErrorHandler implements ErrorHandler {
  static $onError = new Subject<Error>();
  static errorDisplayed = false;

  handleError(error: any) {
    if(isDevMode())
      console.error('handleError' + error);

    AppErrorHandler.$onError.next(error);
  }
}
